/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        // $('.carousel').carousel({
        //     interval: false
        // });


        /*!
         * jQuery UI Touch Punch 0.2.3
         *
         * Copyright 2011–2014, Dave Furfero
         * Dual licensed under the MIT or GPL Version 2 licenses.
         *
         * Depends:
         *  jquery.ui.widget.js
         *  jquery.ui.mouse.js
         */
        (function ($) {

          // Detect touch support
          $.support.touch = 'ontouchend' in document;

          // Ignore browsers without touch support
          if (!$.support.touch) {
            return;
          }

          var mouseProto = $.ui.mouse.prototype,
              _mouseInit = mouseProto._mouseInit,
              _mouseDestroy = mouseProto._mouseDestroy,
              touchHandled;

          /**
           * Simulate a mouse event based on a corresponding touch event
           * @param {Object} event A touch event
           * @param {String} simulatedType The corresponding mouse event
           */
          function simulateMouseEvent (event, simulatedType) {

            // Ignore multi-touch events
            if (event.originalEvent.touches.length > 1) {
              return;
            }

            event.preventDefault();

            var touch = event.originalEvent.changedTouches[0],
                simulatedEvent = document.createEvent('MouseEvents');

            // Initialize the simulated mouse event using the touch event's coordinates
            simulatedEvent.initMouseEvent(
              simulatedType,    // type
              true,             // bubbles
              true,             // cancelable
              window,           // view
              1,                // detail
              touch.screenX,    // screenX
              touch.screenY,    // screenY
              touch.clientX,    // clientX
              touch.clientY,    // clientY
              false,            // ctrlKey
              false,            // altKey
              false,            // shiftKey
              false,            // metaKey
              0,                // button
              null              // relatedTarget
            );

            // Dispatch the simulated event to the target element
            event.target.dispatchEvent(simulatedEvent);
          }

          /**
           * Handle the jQuery UI widget's touchstart events
           * @param {Object} event The widget element's touchstart event
           */
          mouseProto._touchStart = function (event) {

            var self = this;

            // Ignore the event if another widget is already being handled
            if (touchHandled || !self._mouseCapture(event.originalEvent.changedTouches[0])) {
              return;
            }

            // Set the flag to prevent other widgets from inheriting the touch event
            touchHandled = true;

            // Track movement to determine if interaction was a click
            self._touchMoved = false;

            // Simulate the mouseover event
            simulateMouseEvent(event, 'mouseover');

            // Simulate the mousemove event
            simulateMouseEvent(event, 'mousemove');

            // Simulate the mousedown event
            simulateMouseEvent(event, 'mousedown');
          };

          /**
           * Handle the jQuery UI widget's touchmove events
           * @param {Object} event The document's touchmove event
           */
          mouseProto._touchMove = function (event) {

            // Ignore event if not handled
            if (!touchHandled) {
              return;
            }

            // Interaction was not a click
            this._touchMoved = true;

            // Simulate the mousemove event
            simulateMouseEvent(event, 'mousemove');
          };

          /**
           * Handle the jQuery UI widget's touchend events
           * @param {Object} event The document's touchend event
           */
          mouseProto._touchEnd = function (event) {

            // Ignore event if not handled
            if (!touchHandled) {
              return;
            }

            // Simulate the mouseup event
            simulateMouseEvent(event, 'mouseup');

            // Simulate the mouseout event
            simulateMouseEvent(event, 'mouseout');

            // If the touch interaction did not move, it should trigger a click
            if (!this._touchMoved) {

              // Simulate the click event
              simulateMouseEvent(event, 'click');
            }

            // Unset the flag to allow other widgets to inherit the touch event
            touchHandled = false;
          };

          /**
           * A duck punch of the $.ui.mouse _mouseInit method to support touch events.
           * This method extends the widget with bound touch event handlers that
           * translate touch events to mouse events and pass them to the widget's
           * original mouse event handling methods.
           */
          mouseProto._mouseInit = function () {

            var self = this;

            // Delegate the touch handlers to the widget's element
            self.element.bind({
              touchstart: $.proxy(self, '_touchStart'),
              touchmove: $.proxy(self, '_touchMove'),
              touchend: $.proxy(self, '_touchEnd')
            });

            // Call the original $.ui.mouse init method
            _mouseInit.call(self);
          };

          /**
           * Remove the touch event handlers
           */
          mouseProto._mouseDestroy = function () {

            var self = this;

            // Delegate the touch handlers to the widget's element
            self.element.unbind({
              touchstart: $.proxy(self, '_touchStart'),
              touchmove: $.proxy(self, '_touchMove'),
              touchend: $.proxy(self, '_touchEnd')
            });

            // Call the original $.ui.mouse destroy method
            _mouseDestroy.call(self);
          };

        })(jQuery);


        // Horizontal History slider
        jQuery.fn.timelinr = function(options){
        	// default plugin settings
        	settings = jQuery.extend({
        		orientation: 							'horizontal',	// value: horizontal | vertical, default to horizontal
        		containerDiv: 						'#timeline',	// value: any HTML tag or #id, default to #timeline
        		datesDiv: 								'#dates',			// value: any HTML tag or #id, default to #dates
        		datesSelectedClass: 			'selected',		// value: any class, default to selected
        		datesSpeed: 							'normal',			// value: integer between 100 and 1000 (recommended) or 'slow', 'normal' or 'fast'; default to normal
        		issuesDiv: 								'#issues',		// value: any HTML tag or #id, default to #issues
        		issuesSelectedClass: 			'selected',		// value: any class, default to selected
        		issuesSpeed: 							'fast',				// value: integer between 100 and 1000 (recommended) or 'slow', 'normal' or 'fast'; default to fast
        		issuesTransparency: 			0.2,					// value: integer between 0 and 1 (recommended), default to 0.2
        		issuesTransparencySpeed: 	500,					// value: integer between 100 and 1000 (recommended), default to 500 (normal)
        		prevButton: 							'#prev',			// value: any HTML tag or #id, default to #prev
        		nextButton: 							'#next',			// value: any HTML tag or #id, default to #next
        		arrowKeys: 								'false',			// value: true | false, default to false
        		startAt: 									1,						// value: integer, default to 1 (first)
        		autoPlay: 								'false',			// value: true | false, default to false
        		autoPlayDirection: 				'forward',		// value: forward | backward, default to forward
        		autoPlayPause: 						2000					// value: integer (1000 = 1 seg), default to 2000 (2segs)
        	}, options);

        	$(function(){
        		// Checks if required elements exist on page before initializing timelinr | improvement since 0.9.55
        		if ($(settings.datesDiv).length > 0 && $(settings.issuesDiv).length > 0) {
        			// setting variables... many of them
        			var howManyDates = $(settings.datesDiv+' li').length;
        			var howManyIssues = $(settings.issuesDiv+' li').length;
        			var currentDate = $(settings.datesDiv).find('a.'+settings.datesSelectedClass);
        			var currentIssue = $(settings.issuesDiv).find('li.'+settings.issuesSelectedClass);
        			var widthContainer = $(settings.containerDiv).width();
        			var heightContainer = $(settings.containerDiv).height();
        			var widthIssues = $(settings.issuesDiv).width();
        			var heightIssues = $(settings.issuesDiv).height();
        			var widthIssue = $(settings.issuesDiv+' li').width();
        			var heightIssue = $(settings.issuesDiv+' li').height();
        			var widthDates = $(settings.datesDiv).width();
        			var heightDates = $(settings.datesDiv).height();
        			var widthDate = $(settings.datesDiv+' li').width();
        			var heightDate = $(settings.datesDiv+' li').height();
        			// set positions!
        			if(settings.orientation === 'horizontal') {
        				$(settings.issuesDiv).width(widthIssue*howManyIssues);
        				$(settings.datesDiv).width(widthDate*howManyDates).css('marginLeft',widthContainer/2-widthDate/2);
        				var defaultPositionDates = parseInt($(settings.datesDiv).css('marginLeft').substring(0,$(settings.datesDiv).css('marginLeft').indexOf('px')));
        			}

        			$(settings.datesDiv+' a').click(function(event){

                $('#timeline ul li').removeClass('history-biggest-circle');
                $('#timeline ul li').removeClass('history-middle-circle');
                $(this).parent('li').addClass('history-biggest-circle');
                $(this).parent('li').removeClass('history-middle-circle');
                $(this).parent('li').next('li').removeClass('history-biggest-circle');
                $(this).parent('li').prev('li').removeClass('history-biggest-circle');
                $(this).parent('li').next('li').addClass('history-middle-circle');
                $(this).parent('li').prev('li').addClass('history-middle-circle');


        				event.preventDefault();
        				// first vars
        				var whichIssue = $(this).text();
        				var currentIndex = $(this).parent().prevAll().length;
        				// moving the elements
        				if(settings.orientation === 'horizontal') {
        					$(settings.issuesDiv).animate({'marginLeft':-widthIssue*currentIndex},{queue:false, duration:settings.issuesSpeed});
        				} else if(settings.orientation === 'vertical') {
        					$(settings.issuesDiv).animate({'marginTop':-heightIssue*currentIndex},{queue:false, duration:settings.issuesSpeed});
        				}
        				$(settings.issuesDiv+' li').animate({'opacity':settings.issuesTransparency},{queue:false, duration:settings.issuesSpeed}).removeClass(settings.issuesSelectedClass).eq(currentIndex).addClass(settings.issuesSelectedClass).fadeTo(settings.issuesTransparencySpeed,1);
        				// prev/next buttons now disappears on first/last issue | bugfix from 0.9.51: lower than 1 issue hide the arrows | bugfixed: arrows not showing when jumping from first to last date
        				if(howManyDates === 1) {
        					$(settings.prevButton+','+settings.nextButton).fadeOut('fast');
        				} else if(howManyDates === 2) {
        					if($(settings.issuesDiv+' li:first-child').hasClass(settings.issuesSelectedClass)) {
        						$(settings.prevButton).fadeOut('fast');
        					 	$(settings.nextButton).fadeIn('fast');
        					}
        					else if($(settings.issuesDiv+' li:last-child').hasClass(settings.issuesSelectedClass)) {
        						$(settings.nextButton).fadeOut('fast');
        						$(settings.prevButton).fadeIn('fast');
        					}
        				} else {
        					if( $(settings.issuesDiv+' li:first-child').hasClass(settings.issuesSelectedClass) ) {
        						$(settings.nextButton).fadeIn('fast');
        						$(settings.prevButton).fadeOut('fast');
        					}
        					else if( $(settings.issuesDiv+' li:last-child').hasClass(settings.issuesSelectedClass) ) {
        						$(settings.prevButton).fadeIn('fast');
        						$(settings.nextButton).fadeOut('fast');
        					}
        					else {
        						$(settings.nextButton+','+settings.prevButton).fadeIn('slow');
        					}
        				}
        				// now moving the dates
        				$(settings.datesDiv+' a').removeClass(settings.datesSelectedClass);
        				$(this).addClass(settings.datesSelectedClass);
        				if(settings.orientation === 'horizontal') {
        					$(settings.datesDiv).animate({'marginLeft':defaultPositionDates-(widthDate*currentIndex)},{queue:false, duration:'settings.datesSpeed'});
        				} else if(settings.orientation === 'vertical') {
        					$(settings.datesDiv).animate({'marginTop':defaultPositionDates-(heightDate*currentIndex)},{queue:false, duration:'settings.datesSpeed'});
        				}
        			});

        			$(settings.nextButton).bind('click', function(event){
        				event.preventDefault();
        				// bugixed from 0.9.54: now the dates gets centered when there's too much dates.
        				var currentIndex = $(settings.issuesDiv).find('li.'+settings.issuesSelectedClass).index();
        				if(settings.orientation === 'horizontal') {
        					var currentPositionIssues = parseInt($(settings.issuesDiv).css('marginLeft').substring(0,$(settings.issuesDiv).css('marginLeft').indexOf('px')));
        					var currentIssueIndex = currentPositionIssues/widthIssue;
        					var currentPositionDates = parseInt($(settings.datesDiv).css('marginLeft').substring(0,$(settings.datesDiv).css('marginLeft').indexOf('px')));
        					var currentIssueDate = currentPositionDates-widthDate;
        					if(currentPositionIssues <= -(widthIssue*howManyIssues-(widthIssue))) {
        						$(settings.issuesDiv).stop();
        						$(settings.datesDiv+' li:last-child a').click();
        					} else {
        						if (!$(settings.issuesDiv).is(':animated')) {
        							// bugixed from 0.9.52: now the dates gets centered when there's too much dates.
        							$(settings.datesDiv+' li').eq(currentIndex+1).find('a').trigger('click');
        						}
        					}
        				}
        				// prev/next buttons now disappears on first/last issue | bugfix from 0.9.51: lower than 1 issue hide the arrows
        				if(howManyDates === 1) {
        					$(settings.prevButton+','+settings.nextButton).fadeOut('fast');
        				} else if(howManyDates === 2) {
        					if($(settings.issuesDiv+' li:first-child').hasClass(settings.issuesSelectedClass)) {
        						$(settings.prevButton).fadeOut('fast');
        					 	$(settings.nextButton).fadeIn('fast');
        					}
        					else if($(settings.issuesDiv+' li:last-child').hasClass(settings.issuesSelectedClass)) {
        						$(settings.nextButton).fadeOut('fast');
        						$(settings.prevButton).fadeIn('fast');
        					}
        				} else {
        					if( $(settings.issuesDiv+' li:first-child').hasClass(settings.issuesSelectedClass) ) {
        						$(settings.prevButton).fadeOut('fast');
        					}
        					else if( $(settings.issuesDiv+' li:last-child').hasClass(settings.issuesSelectedClass) ) {
        						$(settings.nextButton).fadeOut('fast');
        					}
        					else {
        						$(settings.nextButton+','+settings.prevButton).fadeIn('slow');
        					}
        				}
        			});

        			$(settings.prevButton).click(function(event){
        				event.preventDefault();
        				// bugixed from 0.9.54: now the dates gets centered when there's too much dates.
        				var currentIndex = $(settings.issuesDiv).find('li.'+settings.issuesSelectedClass).index();
        				if(settings.orientation === 'horizontal') {
        					var currentPositionIssues = parseInt($(settings.issuesDiv).css('marginLeft').substring(0,$(settings.issuesDiv).css('marginLeft').indexOf('px')));
        					var currentIssueIndex = currentPositionIssues/widthIssue;
        					var currentPositionDates = parseInt($(settings.datesDiv).css('marginLeft').substring(0,$(settings.datesDiv).css('marginLeft').indexOf('px')));
        					var currentIssueDate = currentPositionDates+widthDate;
        					if(currentPositionIssues >= 0) {
        						$(settings.issuesDiv).stop();
        						$(settings.datesDiv+' li:first-child a').click();
        					} else {
        						if (!$(settings.issuesDiv).is(':animated')) {
        							// bugixed from 0.9.54: now the dates gets centered when there's too much dates.
        							$(settings.datesDiv+' li').eq(currentIndex-1).find('a').trigger('click');
        						}
        					}
        				}
        				// prev/next buttons now disappears on first/last issue | bugfix from 0.9.51: lower than 1 issue hide the arrows
        				if(howManyDates === 1) {
        					$(settings.prevButton+','+settings.nextButton).fadeOut('fast');
        				} else if(howManyDates === 2) {
        					if($(settings.issuesDiv+' li:first-child').hasClass(settings.issuesSelectedClass)) {
        						$(settings.prevButton).fadeOut('fast');
        					 	$(settings.nextButton).fadeIn('fast');
        					}
        					else if($(settings.issuesDiv+' li:last-child').hasClass(settings.issuesSelectedClass)) {
        						$(settings.nextButton).fadeOut('fast');
        						$(settings.prevButton).fadeIn('fast');
        					}
        				} else {
        					if( $(settings.issuesDiv+' li:first-child').hasClass(settings.issuesSelectedClass) ) {
        						$(settings.prevButton).fadeOut('fast');
        					}
        					else if( $(settings.issuesDiv+' li:last-child').hasClass(settings.issuesSelectedClass) ) {
        						$(settings.nextButton).fadeOut('fast');
        					}
        					else {
        						$(settings.nextButton+','+settings.prevButton).fadeIn('slow');
        					}
        				}
        			});
        			// keyboard navigation, added since 0.9.1
        			if(settings.arrowKeys==='true') {
        				if(settings.orientation==='horizontal') {
        					$(document).keydown(function(event){
        						if (event.keyCode === 39) {
        					       $(settings.nextButton).click();
        					    }
        						if (event.keyCode === 37) {
        					       $(settings.prevButton).click();
        					    }
        					});
        				} else if(settings.orientation==='vertical') {
        					$(document).keydown(function(event){
        						if (event.keyCode === 40) {
        					       $(settings.nextButton).click();
        					    }
        						if (event.keyCode === 38) {
        					       $(settings.prevButton).click();
        					    }
        					});
        				}
        			}
        			// default position startAt, added since 0.9.3
        			$(settings.datesDiv+' li').eq(settings.startAt-1).find('a').trigger('click');
        			// autoPlay, added since 0.9.4
        			// if(settings.autoPlay === 'true') {
        			// 	setInterval("autoPlay()", settings.autoPlayPause);
        			// }
        		}
        	});
        };

        // autoPlay, added since 0.9.4
        function autoPlay(){
        	var currentDate = $(settings.datesDiv).find('a.'+settings.datesSelectedClass);
        	if(settings.autoPlayDirection === 'forward') {
        		if(currentDate.parent().is('li:last-child')) {
        			$(settings.datesDiv+' li:first-child').find('a').trigger('click');
        		} else {
        			currentDate.parent().next().find('a').trigger('click');
        		}
        	} else if(settings.autoPlayDirection === 'backward') {
        		if(currentDate.parent().is('li:first-child')) {
        			$(settings.datesDiv+' li:last-child').find('a').trigger('click');
        		} else {
        			currentDate.parent().prev().find('a').trigger('click');
        		}
        	}
        }
        $(function(){
          $().timelinr({
            arrowKeys: 'true'
          });
        });


        //Jobs plus minus
        $( '.panel-title a' ).click(function() {
          if ( !$( '.panel-title a' ).hasClass( 'collapsed' ) ) {
            $('.accordionplus').text('-');
          } else {
            $('.accordionplus').text('+');
          }
        });


        $('.jobs-slider').each(function() {
          var $slides = $(this).find('.slides');
          $slides.slick({
            arrows: false,
            fade: true,
            speed: 500
          });
          $(this).find('.arrow.prev').click(function() {
            $slides.slick('slickPrev')
          });
          $(this).find('.arrow.next').click(function() {
            $slides.slick('slickNext')
          });
        });


        //Initializes Select2
        $('#ninja_forms_field_6').select2();
        $('#ninja_forms_field_12').select2();
        $('#destination-dropdown').select2();


        // Hides scrollen sie on verticall scroll
        var $fpScrollenSie = $('.scrollen-sie');
        $(window).scroll(function() {
          if ($(window).scrollTop()>100) {
            $fpScrollenSie.addClass('fullopacity');
          } else {
            $fpScrollenSie.removeClass('fullopacity');
          }
        });





        $(document).ready(function() {
            // Optimalisation: Store the references outside the event handler:
            var $window = $(window);

            function checkWidth() {
                var windowsize = $window.width();
                if (windowsize > 767) {

                  // circleType functionality
                  $.fn.circleType = function(options) {
                      var self = this,
                          settings = {
                          dir: 1,
                          position: 'relative',
                      };
                      if (typeof($.fn.lettering) !== 'function') {
                          console.log('Lettering.js is required');
                          return;
                      }
                      return this.each(function () {
                          if (options) {
                              $.extend(settings, options);
                          }
                          var elem = this,
                              delta = (180 / Math.PI),
                              fs = parseInt($(elem).css('font-size'), 10),
                              ch = parseInt($(elem).css('line-height'), 10) || fs,
                              txt = elem.innerHTML.replace(/^\s+|\s+$/g, '').replace(/\s/g, '&nbsp;'),
                              letters,
                              center;
                          elem.innerHTML = txt;
                          $(elem).lettering();
                          elem.style.position =  settings.position;
                          letters = elem.getElementsByTagName('span');
                          center = Math.floor(letters.length / 2);
                          var layout = function () {
                              var tw = 0,
                                  i,
                                  offset = 0,
                                  minRadius,
                                  origin,
                                  innerRadius,
                                  l, style, r, transform;
                              for (i = 0; i < letters.length; i++) {
                                  tw += letters[i].offsetWidth;
                              }
                              minRadius = (tw / Math.PI) / 2 + ch;
                              if (settings.fluid && !settings.fitText) {
                                  settings.radius = Math.max(elem.offsetWidth / 2, minRadius);
                              }
                              else if (!settings.radius) {
                                  settings.radius = minRadius;
                              }
                              if (settings.dir === -1) {
                                  origin = 'center ' + (-settings.radius + ch) / fs + 'em';
                              } else {
                                  origin = 'center ' + settings.radius / fs + 'em';
                              }
                              innerRadius = settings.radius - ch;
                              for (i = 0; i < letters.length; i++) {
                                  l = letters[i];
                                  offset += l.offsetWidth / 2 / innerRadius * delta;
                                  l.rot = offset;
                                  offset += l.offsetWidth / 2 / innerRadius * delta;
                              }
                              for (i = 0; i < letters.length; i++) {
                                  l = letters[i];
                                  style = l.style;
                                  r = (-offset * settings.dir / 2) + l.rot * settings.dir;
                                  transform = 'rotate3d(0,0,1,' + r + 'deg)';
                                  style.position = 'absolute';
                                  style.left = '50%';
                                  style.marginLeft = -(l.offsetWidth / 2) / fs + 'em';
                                  style.webkitTransform = transform;
                                  style.MozTransform = transform;
                                  style.OTransform = transform;
                                  style.msTransform = transform;
                                  style.transform = transform;
                                  style.webkitTransformOrigin = origin;
                                  style.MozTransformOrigin = origin;
                                  style.OTransformOrigin = origin;
                                  style.msTransformOrigin = origin;
                                  style.transformOrigin = origin;
                                  if(settings.dir === -1) {
                                      style.bottom = 0;
                                  }
                              }
                              var getBounds = function (elem) {
                                var docElem = document.documentElement,
                                box = elem.getBoundingClientRect();
                                return {
                                  top: box.top + window.pageYOffset - docElem.clientTop,
                                  left: box.left + window.pageXOffset - docElem.clientLeft,
                                  height: box.height
                                };
                              };
                              var updateHeight = function () {
                                var mid = getBounds(letters[center]),
                                first = getBounds(letters[0]),
                                h;
                                if (mid.top < first.top) {
                                  h = first.top - mid.top + first.height;
                                } else {
                                  h = mid.top - first.top + first.height;
                                }
                                elem.style.height = h + 'px';
                              };
                              if (settings.fitText) {
                                  if (typeof($.fn.fitText) !== 'function') {
                                      console.log('FitText.js is required when using the fitText option');
                                  } else {
                                      $(elem).fitText();
                                      $(window).resize(function () {
                                          updateHeight();
                                      });
                                  }
                              }
                              updateHeight();

                              if (typeof settings.callback === 'function') {
                                  // Execute our callback with the element we transformed as `this`
                                  settings.callback.apply(elem);
                              }
                          };
                          if (settings.fluid && !settings.fitText) {
                              $(window).resize(function () {
                                  layout();
                              });
                          }
                          if (document.readyState !== "complete") {
                              elem.style.visibility = 'hidden';
                              $(window).on('load', function () {
                                  elem.style.visibility = 'visible';
                                  layout();
                              });
                          } else {
                              layout();
                          }
                      });
                  };



                  $(function() {
                    $( ".nav-holder" ).draggable({
                      containment: ".nav-containment-wrapper",
                      scroll: false
                    });
                  });

                  $(function() {
                    $('.fullscreendim').click(function (){
                      $('.fullscreendim').addClass('fullscreendimnone');
                      $( ".menu-produkte_navigation-container" ).addClass('fullopacity');
                      $( ".menu-service_navigation-container" ).addClass('fullopacity');
                      $( ".menu-technik_navigation-container" ).addClass('fullopacity');
                      $( ".menu-uber_uns_navigation-container" ).addClass('fullopacity');
                      $('.outer-ring-nav, .outer-ring-txt').css({
                        '-webkit-transform' : 'rotate3d(0,0,1,0deg)',
                        '-moz-transform' : 'rotate3d(0,0,1,0deg)',
                        '-ms-transform' : 'rotate3d(0,0,1,0deg)',
                        'transform' : 'rotate3d(0,0,1,0deg)',
                      });
                      setTimeout( function () {
                        $('.outer-ring-txt').css('background-image', 'url(https://www.altmann-industrietechnik.de/wp-content/themes/altmann/dist/images/ring-beschriftung.png)');
                      }, 100);
                    });
                  });

                  $(function() {
                    $('.produkte1').click(function (){
                      $('.fullscreendim').removeClass('fullscreendimnone');
                      $( ".menu-produkte_navigation-container" ).removeClass('fullopacity');
                      $( ".menu-service_navigation-container" ).addClass('fullopacity');
                      $( ".menu-technik_navigation-container" ).addClass('fullopacity');
                      $( ".menu-uber_uns_navigation-container" ).addClass('fullopacity');
                      $('.outer-ring-nav, .outer-ring-txt').css({
                        '-webkit-transform' : 'rotate3d(0,0,1,-135deg)',
                        '-moz-transform' : 'rotate3d(0,0,1,-135deg)',
                        '-ms-transform' : 'rotate3d(0,0,1,-135deg)',
                        'transform' : 'rotate3d(0,0,1,-135deg)',
                      });
                      setTimeout( function () {
                        $('.outer-ring-txt').css('background-image', 'url(https://www.altmann-industrietechnik.de/wp-content/themes/altmann/dist/images/produkte-text.svg)');
                      }, 100);
                    });
                  });

                  $(function() {
                    $('.service1').click(function (){
                      $('.fullscreendim').removeClass('fullscreendimnone');
                      $( ".menu-service_navigation-container" ).removeClass('fullopacity');
                      $( ".menu-produkte_navigation-container" ).addClass('fullopacity');
                      $( ".menu-technik_navigation-container" ).addClass('fullopacity');
                      $( ".menu-uber_uns_navigation-container" ).addClass('fullopacity');
                      $('.outer-ring-nav, .outer-ring-txt').css({
                        '-webkit-transform' : 'rotate3d(0,0,1,135deg)',
                        '-moz-transform' : 'rotate3d(0,0,1,135deg)',
                        '-ms-transform' : 'rotate3d(0,0,1,135deg)',
                        'transform' : 'rotate3d(0,0,1,135deg)',
                      });
                      setTimeout( function () {
                        $('.outer-ring-txt').css('background-image', 'url(https://www.altmann-industrietechnik.de/wp-content/themes/altmann/dist/images/service-text.svg)');
                      }, 100);
                    });
                  });

                  $(function() {
                    $('.technik1').click(function (){
                      $('.fullscreendim').removeClass('fullscreendimnone');
                      $( ".menu-technik_navigation-container" ).removeClass('fullopacity');
                      $( ".menu-produkte_navigation-container" ).addClass('fullopacity');
                      $( ".menu-service_navigation-container" ).addClass('fullopacity');
                      $( ".menu-uber_uns_navigation-container" ).addClass('fullopacity');
                      $('.outer-ring-nav, .outer-ring-txt').css({
                        '-webkit-transform' : 'rotate3d(0,0,1,45deg)',
                        '-moz-transform' : 'rotate3d(0,0,1,45deg)',
                        '-ms-transform' : 'rotate3d(0,0,1,45deg)',
                        'transform' : 'rotate3d(0,0,1,45deg)',
                      });
                      setTimeout( function () {
                        $('.outer-ring-txt').css('background-image', 'url(https://www.altmann-industrietechnik.de/wp-content/themes/altmann/dist/images/technik-text.svg)');
                      }, 100);
                    });
                  });

                  $(function() {
                    $('.uber1').click(function (){
                      $('.fullscreendim').removeClass('fullscreendimnone');
                      $( ".menu-uber_uns_navigation-container" ).removeClass('fullopacity');
                      $( ".menu-produkte_navigation-container" ).addClass('fullopacity');
                      $( ".menu-service_navigation-container" ).addClass('fullopacity');
                      $( ".menu-technik_navigation-container" ).addClass('fullopacity');
                      $('.outer-ring-nav, .outer-ring-txt').css({
                        '-webkit-transform' : 'rotate3d(0,0,1,-45deg)',
                        '-moz-transform' : 'rotate3d(0,0,1,-45deg)',
                        '-ms-transform' : 'rotate3d(0,0,1,-45deg)',
                        'transform' : 'rotate3d(0,0,1,-45deg)',
                      });
                      setTimeout( function () {
                        $('.outer-ring-txt').css('background-image', 'url(https://www.altmann-industrietechnik.de/wp-content/themes/altmann/dist/images/uber-text.svg)');
                      }, 100);
                    });
                  });

                  $(function() {
                    $('.uber1, .technik1, .service1, .produkte1').click(function (){
                      setTimeout( function () {
                        $('.inner-ring').css({
                          '-webkit-transform' : 'rotate3d(0,0,1,0deg)',
                          '-moz-transform' : 'rotate3d(0,0,1,0deg)',
                          '-ms-transform' : 'rotate3d(0,0,1,0deg)',
                          'transform' : 'rotate3d(0,0,1,0deg)',
                        });
                      }, 500);
                    });
                  });

                  $( ".menu-produkte_navigation-container, .menu-service_navigation-container, .menu-technik_navigation-container, .menu-uber_uns_navigation-container" ).addClass('fullopacity');
                  $(function() {
                    $( "#menu-produkte_navigation-1 li:first-child a" ).wrapInner( '<span class="produktemmm"></span>' );
                    $( "#menu-produkte_navigation-1 li:nth-child(2) a" ).wrapInner( '<span class="produkte2"></span>' );
                    $( "#menu-produkte_navigation-1 li:nth-child(3) a" ).wrapInner( '<span class="produkte3"></span>' );
                    $( "#menu-produkte_navigation-1 li:nth-child(4) a" ).wrapInner( '<span class="produkte4"></span>' );
                    $( "#menu-produkte_navigation-1 li:nth-child(5) a" ).wrapInner( '<span class="produkte5"></span>' );
                    $( "#menu-produkte_navigation-1 li:nth-child(6) a" ).wrapInner( '<span class="produkte6"></span>' );
                    $( "#menu-produkte_navigation-1 li:nth-child(7) a" ).wrapInner( '<span class="produkte7"></span>' );
                    $( "#menu-produkte_navigation-1 li:nth-child(8) a" ).wrapInner( '<span class="produkte8"></span>' );
                    $( "#menu-produkte_navigation-1 li:nth-child(9) a" ).wrapInner( '<span class="produkte9"></span>' );
                    $( "#menu-produkte_navigation-1 li:nth-child(10) a" ).wrapInner( '<span class="produkte10"></span>' );
                    $( "#menu-service_navigation-1 li:first-child a" ).wrapInner( '<span class="produktemmm"></span>' );
                    $( "#menu-service_navigation-1 li:nth-child(2) a" ).wrapInner( '<span class="produkte2"></span>' );
                    $( "#menu-service_navigation-1 li:nth-child(3) a" ).wrapInner( '<span class="produkte3"></span>' );
                    $( "#menu-service_navigation-1 li:nth-child(4) a" ).wrapInner( '<span class="produkte4"></span>' );
                    $( "#menu-service_navigation-1 li:nth-child(5) a" ).wrapInner( '<span class="produkte5"></span>' );
                    $( "#menu-service_navigation-1 li:nth-child(6) a" ).wrapInner( '<span class="produkte6"></span>' );
                    $( "#menu-service_navigation-1 li:nth-child(7) a" ).wrapInner( '<span class="produkte7"></span>' );
                    $( "#menu-service_navigation-1 li:nth-child(8) a" ).wrapInner( '<span class="produkte8"></span>' );
                    $( "#menu-service_navigation-1 li:nth-child(9) a" ).wrapInner( '<span class="produkte9"></span>' );
                    $( "#menu-service_navigation-1 li:nth-child(10) a" ).wrapInner( '<span class="produkte10"></span>' );
                    $( "#menu-technik_navigation-1 li:first-child a" ).wrapInner( '<span class="produktemmm"></span>' );
                    $( "#menu-technik_navigation-1 li:nth-child(2) a" ).wrapInner( '<span class="produkte2"></span>' );
                    $( "#menu-technik_navigation-1 li:nth-child(3) a" ).wrapInner( '<span class="produkte3"></span>' );
                    $( "#menu-technik_navigation-1 li:nth-child(4) a" ).wrapInner( '<span class="produkte4"></span>' );
                    $( "#menu-technik_navigation-1 li:nth-child(5) a" ).wrapInner( '<span class="produkte5"></span>' );
                    $( "#menu-technik_navigation-1 li:nth-child(6) a" ).wrapInner( '<span class="produkte6"></span>' );
                    $( "#menu-technik_navigation-1 li:nth-child(7) a" ).wrapInner( '<span class="produkte7"></span>' );
                    $( "#menu-technik_navigation-1 li:nth-child(8) a" ).wrapInner( '<span class="produkte8"></span>' );
                    $( "#menu-technik_navigation-1 li:nth-child(9) a" ).wrapInner( '<span class="produkte9"></span>' );
                    $( "#menu-technik_navigation-1 li:nth-child(10) a" ).wrapInner( '<span class="produkte10"></span>' );
                    $( "#menu-uber_uns_navigation-1 li:first-child a" ).wrapInner( '<span class="produktemmm"></span>' );
                    $( "#menu-uber_uns_navigation-1 li:nth-child(2) a" ).wrapInner( '<span class="produkte2"></span>' );
                    $( "#menu-uber_uns_navigation-1 li:nth-child(3) a" ).wrapInner( '<span class="produkte3"></span>' );
                    $( "#menu-uber_uns_navigation-1 li:nth-child(4) a" ).wrapInner( '<span class="produkte4"></span>' );
                    $( "#menu-uber_uns_navigation-1 li:nth-child(5) a" ).wrapInner( '<span class="produkte5"></span>' );
                    $( "#menu-uber_uns_navigation-1 li:nth-child(6) a" ).wrapInner( '<span class="produkte6"></span>' );
                    $( "#menu-uber_uns_navigation-1 li:nth-child(7) a" ).wrapInner( '<span class="produkte7"></span>' );
                    $( "#menu-uber_uns_navigation-1 li:nth-child(8) a" ).wrapInner( '<span class="produkte8"></span>' );
                    $( "#menu-uber_uns_navigation-1 li:nth-child(9) a" ).wrapInner( '<span class="produkte9"></span>' );
                    $( "#menu-uber_uns_navigation-1 li:nth-child(10) a" ).wrapInner( '<span class="produkte10"></span>' );
                  });

                  $(function() {
                    $('.produktemmm').circleType({radius: 130, dir:-1});
                    $('.produkte2').circleType({radius: 140, dir:-1});
                    $('.produkte3').circleType({radius: 150, dir:-1});
                    $('.produkte4').circleType({radius: 160, dir:-1});
                    $('.produkte5').circleType({radius: 170, dir:-1});
                    $('.produkte6').circleType({radius: 180, dir:-1});
                    $('.produkte7').circleType({radius: 190, dir:-1});
                    $('.produkte8').circleType({radius: 200, dir:-1});
                    $('.produkte9').circleType({radius: 210, dir:-1});
                    $('.produkte10').circleType({radius: 220, dir:-1});
                  });
                } else {

                  //removes the opacity from desktop view
                  $( ".menu-produkte_navigation-container, .menu-service_navigation-container, .menu-technik_navigation-container, .menu-uber_uns_navigation-container" ).removeClass('fullopacity');
                  //main selector

                  $('.hamburger').on('vclick touchend', function(e) {
                      e.stopImmediatePropagation();
                    $('.mobile-menu-container').slideToggle( "slow" );
                    $('.hamburger').toggleClass('open');
                  });
                  //main ul

                  $('.mobile-uber-uns').on('vclick touchend', function(e) {
                      e.stopImmediatePropagation();
                    $('.primary-navigation-1').slideToggle(600);
                    if ($('.mobile-plus1').is(":visible")) {
                      $('.mobile-plus1').hide();
                      $('.mobile-minus1').show();
                    } else {
                      $('.mobile-plus1').show();
                      $('.mobile-minus1').hide();
                    }
                    if ($('.mobile-menu-arrow1').hasClass('rotate0')) {
                      $('.mobile-menu-arrow1').addClass('rotate90').removeClass('rotate0');
                    } else {
                      $('.mobile-menu-arrow1').addClass('rotate0').removeClass('rotate90');
                    }
                    $('.mobile-plus2, .mobile-plus3, .mobile-plus4').show();
                    $('.mobile-minus2, .mobile-minus3, .mobile-minus4').hide();
                    $('.primary-navigation-2, .primary-navigation-3, .primary-navigation-4').slideUp(600);
                    $('.mobile-menu-arrow2, .mobile-menu-arrow3, .mobile-menu-arrow4').addClass('rotate0').removeClass('rotate90');
                  });

                  $('.mobile-technik').on('vclick touchend', function(e) {
                      e.stopImmediatePropagation();
                    $('.primary-navigation-2').slideToggle(600);
                    if ($('.mobile-plus2').is(":visible")) {
                      $('.mobile-plus2').hide();
                      $('.mobile-minus2').show();
                    } else {
                      $('.mobile-plus2').show();
                      $('.mobile-minus2').hide();
                    }
                    if ($('.mobile-menu-arrow2').hasClass('rotate0')) {
                      $('.mobile-menu-arrow2').addClass('rotate90').removeClass('rotate0');
                    } else {
                      $('.mobile-menu-arrow2').addClass('rotate0').removeClass('rotate90');
                    }
                    $('.mobile-plus1, .mobile-plus3, .mobile-plus4').show();
                    $('.mobile-minus1, .mobile-minus3, .mobile-minus4').hide();
                    $('.primary-navigation-1, .primary-navigation-3, .primary-navigation-4').slideUp(600);
                    $('.mobile-menu-arrow1, .mobile-menu-arrow3, .mobile-menu-arrow4').addClass('rotate0').removeClass('rotate90');
                  });

                  $('.mobile-service').on('vclick touchend', function(e) {
                      e.stopImmediatePropagation();
                    $('.primary-navigation-3').slideToggle(600);
                    if ($('.mobile-plus3').is(":visible")) {
                      $('.mobile-plus3').hide();
                      $('.mobile-minus3').show();
                    } else {
                      $('.mobile-plus3').show();
                      $('.mobile-minus3').hide();
                    }
                    if ($('.mobile-menu-arrow3').hasClass('rotate0')) {
                      $('.mobile-menu-arrow3').addClass('rotate90').removeClass('rotate0');
                    } else {
                      $('.mobile-menu-arrow3').addClass('rotate0').removeClass('rotate90');
                    }
                    $('.mobile-plus1, .mobile-plus2, .mobile-plus4').show();
                    $('.mobile-minus1, .mobile-minus2, .mobile-minus4').hide();
                    $('.primary-navigation-1, .primary-navigation-2, .primary-navigation-4').slideUp(600);
                    $('.mobile-menu-arrow1, .mobile-menu-arrow2, .mobile-menu-arrow4').addClass('rotate0').removeClass('rotate90');
                  });

                  $('.mobile-produkte').on('vclick touchend', function(e) {
                      e.stopImmediatePropagation();
                    $('.primary-navigation-4').slideToggle(600);
                    if ($('.mobile-plus4').is(":visible")) {
                      $('.mobile-plus4').hide();
                      $('.mobile-minus4').show();
                    } else {
                      $('.mobile-plus4').show();
                      $('.mobile-minus4').hide();
                    }
                    if ($('.mobile-menu-arrow4').hasClass('rotate0')) {
                      $('.mobile-menu-arrow4').addClass('rotate90').removeClass('rotate0');
                    } else {
                      $('.mobile-menu-arrow4').addClass('rotate0').removeClass('rotate90');
                    }
                    $('.mobile-plus1, .mobile-plus2, .mobile-plus3').show();
                    $('.mobile-minus1, .mobile-minus2, .mobile-minus3').hide();
                    $('.primary-navigation-1, .primary-navigation-2, .primary-navigation-3').slideUp(600);
                    $('.mobile-menu-arrow1, .mobile-menu-arrow2, .mobile-menu-arrow3').addClass('rotate0').removeClass('rotate90');
                  });
                }
            }
            // Execute on load
            checkWidth();
            // Bind event listener
            $(window).resize(checkWidth);
        });

        // Toggle single product div


        // $('.fp-test').toggle(function(){
        //   $('.all-single-products-holder').animate({height:'100%'},400);
        //   $('.arrow-holder-u').css({
        //     '-webkit-transform' : 'rotate3d(0,0,1,180deg)',
        //     '-moz-transform' : 'rotate3d(0,0,1,180deg)',
        //     '-ms-transform' : 'rotate3d(0,0,1,180deg)',
        //     'transform' : 'rotate3d(0,0,1,180deg)',
        //   });
        // },function(){
        //   $('.all-single-products-holder').animate({height:620},400);
        //   $('.arrow-holder-u').css({
        //     '-webkit-transform' : 'rotate3d(0,0,1,0deg)',
        //     '-moz-transform' : 'rotate3d(0,0,1,0deg)',
        //     '-ms-transform' : 'rotate3d(0,0,1,0deg)',
        //     'transform' : 'rotate3d(0,0,1,0deg)',
        //   });
        // });




        function ToggleClick() {
        var methods = arguments;
        var count = methods.length;
        return this.each(function(i, item){
            var index = 0;
            $(item).on('click', function() {
                return methods[index++ % count].apply(this, arguments);
            });
          });
        }

        function oneProducts() {
          $('.all-single-products-holder').animate({height:'100%'},400);
          $('.arrow-holder-u').css({
            '-webkit-transform' : 'rotate3d(0,0,1,180deg)',
            '-moz-transform' : 'rotate3d(0,0,1,180deg)',
            '-ms-transform' : 'rotate3d(0,0,1,180deg)',
            'transform' : 'rotate3d(0,0,1,180deg)'
          });
        }

        function twoProducts() {
          $('.all-single-products-holder').animate({height:620},400);
          $('.arrow-holder-u').css({
            '-webkit-transform' : 'rotate3d(0,0,1,0deg)',
            '-moz-transform' : 'rotate3d(0,0,1,0deg)',
            '-ms-transform' : 'rotate3d(0,0,1,0deg)',
            'transform' : 'rotate3d(0,0,1,0deg)'
          });
        }

        // $('.fp-test').ToggleClick( oneProducts(), twoProducts() );



        $(document).ready(function($){

          $('.btn-single-product-gesamt').on('click',function(e){

            if($(this).attr('data-click-state') == 1) {
              $(this).attr('data-click-state', 0);

              $('.all-single-products-holder').animate({height:'100%'},400);
              $('.arrow-holder-u').css({
                '-webkit-transform' : 'rotate3d(0,0,1,180deg)',
                '-moz-transform' : 'rotate3d(0,0,1,180deg)',
                '-ms-transform' : 'rotate3d(0,0,1,180deg)',
                'transform' : 'rotate3d(0,0,1,180deg)'
              });


              e.preventDefault();
            } else {
              $(this).attr('data-click-state', 1);

              $('.all-single-products-holder').animate({height:620},400);
              $('.arrow-holder-u').css({
                '-webkit-transform' : 'rotate3d(0,0,1,0deg)',
                '-moz-transform' : 'rotate3d(0,0,1,0deg)',
                '-ms-transform' : 'rotate3d(0,0,1,0deg)',
                'transform' : 'rotate3d(0,0,1,0deg)'
              });


              e.preventDefault();
            }

          });

        });



        // $('.fp-test').on('click',function(){
        //   if($(this).attr('data-click-state') === 1) {
        //     $(this).attr('data-click-state', 0);
        //     $('.all-single-products-holder').animate({height:'100%'},400);
        //     $('.arrow-holder-u').css({
        //       '-webkit-transform' : 'rotate3d(0,0,1,180deg)',
        //       '-moz-transform' : 'rotate3d(0,0,1,180deg)',
        //       '-ms-transform' : 'rotate3d(0,0,1,180deg)',
        //       'transform' : 'rotate3d(0,0,1,180deg)'
        //     });
        //   } else {
        //     $(this).attr('data-click-state', 1);
        //     $('.all-single-products-holder').animate({height:620},400);
        //     $('.arrow-holder-u').css({
        //       '-webkit-transform' : 'rotate3d(0,0,1,0deg)',
        //       '-moz-transform' : 'rotate3d(0,0,1,0deg)',
        //       '-ms-transform' : 'rotate3d(0,0,1,0deg)',
        //       'transform' : 'rotate3d(0,0,1,0deg)'
        //     });
        //   }
        // });



        // single product PREV/NEXT buttons
        $(document).ready(function(){
        $("div[id^='myModal']").each(function(){
          var currentModal = $(this);
          //click next
          currentModal.find('.btn-single-product-next').click(function(){
            currentModal.modal('hide');
            currentModal.closest("div[id^='myModal']").nextAll("div[id^='myModal']").first().modal('show');
          });
          //click prev
          currentModal.find('.btn-single-product-prev').click(function(){
            currentModal.modal('hide');
            currentModal.closest("div[id^='myModal']").prevAll("div[id^='myModal']").first().modal('show');
          });
        });
      });







        // END AREA


      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

        /*if (window.devicePixelRatio > 1) {
          $('.front-category-inner-wrapper img').prop('src', function(_, src) {
            src = src.replace(/@2x\./, '.');         // strip if it's already there
            return src.replace(/(\.\w+$)/, '@2x$1');
          });
        }*/

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },


    'standorte': {
      init: function() {
        // JavaScript to be fired on the standorte page


        // Google Maps
        //gets the dropdown value


        var selectedPoint = document.getElementById('destination-dropdown').options[document.getElementById('destination-dropdown').selectedIndex].value;
        //var mystr = selectedPoint;
        //var myarr = mystr.split(",");

        var directionDisplay;
        var directionsService = new google.maps.DirectionsService();
        var map;
        var home = selectedPoint;

        function initialize(){
          directionsDisplay = new google.maps.DirectionsRenderer();
          var myOptions =
          {
            zoom:16,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            center: home,
            //styles: [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
          };
          map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);
          directionsDisplay.setMap(map);
          directionsDisplay.setPanel(document.getElementById("directions"));

          var myLatLng = new google.maps.LatLng(51.0679059, 8.8050377);
        }

        function calcRoute(){
          var start1 = document.getElementById("routefrom1").value;
          var start2 = document.getElementById("routefrom2").value;
          var start = start1.concat(start2);

          //gets the dropdown value
          var selectedPoint2 = document.getElementById('destination-dropdown').options[document.getElementById('destination-dropdown').selectedIndex].value;
          //var mystr2 = selectedPoint2;
          //var myarr2 = mystr2.split(",");
          var destinationPoint = selectedPoint2;

          var request =
          {
            origin:start,
            destination:destinationPoint,
            travelMode: google.maps.DirectionsTravelMode.DRIVING
          };
          directionsService.route(request, function(response, status){
            if (status === google.maps.DirectionsStatus.OK){
              directionsDisplay.setDirections(response);
            }
          });
        }
        initialize();
        $('#routeform').submit(function(e){
          calcRoute();
          return false;
        });


        $(function() {
          $('.routenplaner').click(function (){
            setTimeout( function () {
              if ( $('#directions').css('direction') === 'ltr') {
                //$( '#map_canvas' ).addClass('mladen');
                $( '#map_canvas' ).css({
                  'visibility' : 'visible',
                  'position' : 'relative'
                });
              }
            }, 500);
            $('.button-print').css({
              'display' : 'inline-block'
            });
          });
        });


      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS

      }
    },


    'archive': {
      init: function() {
        // JavaScript to be fired on the archive page
        $('.btn-single-product-next').click(function(e) {
          e.preventDefault();
          document.location.hash = $(this).data("productname");
        });
        $('.btn-single-product-prev').click(function(e) {
          e.preventDefault();
          document.location.hash = $(this).data("productname");
          console.log($(this).data("productname"));
        });
        $('.all-single-products a.alt-btn-secondary').click(function(e) {
          e.preventDefault();
          document.location.hash = $(this).data("productname");
        });
        $('.close').click(function(e) {
          e.preventDefault();
          history.pushState('', document.title, window.location.pathname);
        });







      }
    },


    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
